import { Grid, Skeleton, Box } from '@packages/shared';

export const CustomerRatingsFallback = ({
  previewReviewsCount,
  reviewsCount,
}: {
  previewReviewsCount: number;
  reviewsCount: number;
}) => (
  <Grid
    container
    columnSpacing={{ xs: 2, sm: 2, md: 2, lg: 5.5 }}
    rowSpacing={1.5}
    id="customer-ratings"
  >
    <Grid item xs={12} md={6} lg={5} sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      {reviewsCount > 0 && <Skeleton variant="rectangular" height={350} />}
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: '100%',
          height: 150,
          border: '1px dashed',
          borderColor: 'grey.main',
        }}
      >
        <Skeleton variant="circular" width={72} height={72} />
      </Box>
    </Grid>
    <Grid
      item
      xs={12}
      md={6}
      lg={7}
      sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2 }}
    >
      {reviewsCount > 0 && (
        <>
          {[...new Array(previewReviewsCount > 3 ? 3 : previewReviewsCount)].map((_, idx) => (
            <Skeleton
              variant="rectangular"
              width="100%"
              height={165}
              // eslint-disable-next-line react/no-array-index-key
              key={`CustomerRatingsFallbackSkeleton${idx}`}
            />
          ))}
          <Skeleton variant="rectangular" width={220} height={38} />
        </>
      )}
    </Grid>
  </Grid>
);
